import { z } from "zod";

export const spendRequestForFinancialAnalysisSchema = z.object({
  id: z.string(),
  serviceStartDate: z.string(),
  serviceEndDate: z.string().nullish(),
  readableId: z.string(),
  vendor: z.object({
    id: z.string(),
    name: z.string(),
  }),
  spendRequestLines: z.array(
    z.object({
      id: z.string(),
      description: z.string(),
      estimatedCost: z.number(),
      entity: z
        .object({
          id: z.string(),
          name: z.string(),
        })
        .nullish(),
      category: z.object({
        id: z.string(),
        name: z.string(),
      }),
      department: z.object({
        id: z.string(),
        name: z.string(),
      }),
      businessUnit: z
        .object({
          id: z.string(),
          name: z.string(),
        })
        .nullish(),
    }),
  ),
});

export type SpendRequestForFinancialAnalysis = z.infer<
  typeof spendRequestForFinancialAnalysisSchema
>;
